module.exports = __webpack_public_path__ + "thinking.169f63a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/articles/thinking.png
// module id = 3052
// module chunks = 0